import {
    useBuscarHelper
  } from "../../../Commons/Scripts/Utils/webservice-helper.js"; 
import { 
  URL_TARJETAS_DASHBOARD, URL_TOP10_DASHBOARD,
  URL_CLIENTES_AUTOCOMPLETE,
  URL_CLIENTES_GRID_DASHBOARD
 } from '../../../CxC/Scripts/Constantes/constantes.js'

  export const useBuscarTarjetasDashboard = (cuerpo) => {
    const url = URL_TARJETAS_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};
  };

  export const useBuscarTop10Dashboard = (cuerpo) => {
    const url = URL_TOP10_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }

  export const useBuscarClientesAutoComplete = (cuerpo) => {
    const url = URL_CLIENTES_AUTOCOMPLETE;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }

  export const useBuscarClientesGrid = (cuerpo) => {
    const url = URL_CLIENTES_GRID_DASHBOARD;
    const { data, loading, error } = useBuscarHelper(url, cuerpo);
    return {data, loading, error};   
  }